export default __webpack_public_path__ + "static/smart_home-335d8cae9240bb1c2a0743fe2b9024e6.svg";